import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { DataPersistence, fetch } from '@nrwl/angular';

import { AuthPartialState } from './auth.reducer';
import {
  LoadAuth,
  AuthLoaded,
  AuthLoadError,
  AuthActionTypes,
  SignIn,
  SignedIn,
  SignInError,
  SignUp,
  SignedUp,
  SignUpError,
  LogOut,
  LogOutError,
  LoggedOut,
} from './auth.actions';
import { Auth } from 'aws-amplify';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthEffects {
  @Effect() loadAuth$ = this.actions$.pipe(
    ofType(AuthActionTypes.LoadAuth),
    fetch({
      run: (action: LoadAuth, state: AuthPartialState) => {
        return from(Auth.currentSession()).pipe(
          map((data) => {
            return new AuthLoaded(data);
          })
        );
      },

      onError: (action: LoadAuth, error) => {
        this.router.navigate(['/sign-in']);
        this._snackBar.open(error, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new AuthLoadError(error);
      },
    })
  );

  @Effect() signIn$ = this.actions$.pipe(
    ofType(AuthActionTypes.SignIn),
    fetch({
      run: (action: SignIn, state: AuthPartialState) => {
        return from(
          Auth.signIn(action.payload.username, action.payload.password)
        ).pipe(
          map((data) => {
            const group =
              data.signInUserSession.idToken.payload['cognito:groups'][0];

            const url = this.router.serializeUrl(
              this.router.createUrlTree(['/employee'])
            );
            window.open(url, '_self');

            return new SignedIn(data);
          })
        );
      },

      onError: (action: SignIn, error) => {
        this._snackBar.open(error.message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new SignInError(error);
      },
    })
  );

  @Effect() signUp$ = this.actions$.pipe(
    ofType(AuthActionTypes.SignUp),
    fetch({
      run: (action: SignUp, state: AuthPartialState) => {
        return from(
          Auth.signUp({
            username: action.payload.username,
            password: action.payload.password,
            attributes: { email: action.payload.email },
          })
        ).pipe(
          map((data: { user }) => {
            const username = data.user.username;
            const formattedUrl = `https://hl7bvsc4a7.execute-api.ap-south-1.amazonaws.com/v1/role?user=${username}&group=${action.payload.role}`;
            this.http.get(formattedUrl).subscribe(
              (data) => {
                const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/employee/users'])
                );
                window.open(url, '_self');
                this._snackBar.open('User Created Successfully', null, {
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: 'custom-snackbar-success',
                });
              },
              (error) => {
                this._snackBar.open(error.message, null, {
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: 'custom-snackbar-error',
                });
              }
            );

            return new SignedUp(data);
          })
        );
      },

      onError: (action: SignUp, error) => {
        this._snackBar.open(error.message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new SignUpError(error);
      },
    })
  );

  @Effect() logOut$ = this.actions$.pipe(
    ofType(AuthActionTypes.LogOut),
    fetch({
      run: (action: LogOut, state: AuthPartialState) => {
        Auth.signOut();
        this.router.navigate(['/sign-in']);
        return new LoggedOut();
      },

      onError: (action: LogOut, error) => {
        this._snackBar.open(error.message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new LogOutError(error);
      },
    })
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private _snackBar: MatSnackBar,
    public http: HttpClient,
    private dataPersistence: DataPersistence<AuthPartialState>
  ) {}
}
